import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { show } from "redux-modal";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { MsgAlert, AddCommentBox } from "../../components";
import { startAddComment, updateTaggingList } from "../../redux/modules/issues";
import {
  startUploadAttachment,
  handleRemoveAttachment,
  resetAttachmentState,
} from "../../redux/modules/attachments/actionCreators";
import { ATTACHMENT_MODAL } from "../../components/AttachmentModal/AttachmentModal";

@connect(
  (state) => ({
    attachments: state.attachments.attachments,
    postingComment: state.issues.postingComment,
    completingIssue: state.issues.completingIssue,
    usernameList: state.issues.usernameList,
    user: state.auth.user,
  }),
  (dispatch) => ({
    ...bindActionCreators(
      {
        handleRemoveAttachment,
        startAddComment,
        updateTaggingList,
        resetAttachmentState,
      },
      dispatch
    ),
    handleStartUploadAttachment: () => {
      dispatch(startUploadAttachment());
      dispatch(show(ATTACHMENT_MODAL));
    },
  })
)
class AddComment extends Component {
  static propTypes = {
    attachments: PropTypes.array,
    handleStartUploadAttachment: PropTypes.func.isRequired,
    selected: PropTypes.object,
    handleRemoveAttachment: PropTypes.func.isRequired,
    postingComment: PropTypes.bool,
    completingIssue: PropTypes.bool,
    usernameList: PropTypes.array,
    updateTaggingList: PropTypes.func,
    startAddComment: PropTypes.func,
    user: PropTypes.object,
  };

  constructor(props) {
    super(props);

    this.state = {
      hasComment: false,
      value: "",
      commentText: "",
    };
  }

  componentDidMount() {
    // HACK: Temporary fix for lingering global attachments
    this.props.resetAttachmentState();
  }

  handleAddComment = (e, action = "postComment") => {
    const comment = `${this.state.commentText} ??${this.props.user.display_name}??`;
    this.props.startAddComment(
      {
        key: this.props.selected.key,
        text: comment,
      },
      action
    );

    this.setState({
      hasComment: false,
      value: "",
      commentText: "",
    });

    if (this.props.onAddComment) this.props.onAddComment();
  };

  handleCommentTextChange = (newComment, e) => {
    this.setState({
      commentText: newComment,
      hasComment: e.target.value && e.target.value.length > 0,
      value: e.target.value,
    });
  };

  displayErrorMessage = () => {
    const message = this.props.error ? "There was an error in submit." : null;
    return <MsgAlert type="error" message={message} />;
  };

  render() {
    const isDisabled = !(
      this.props.selected &&
      this.props.selected.key &&
      this.state.hasComment
    );

    return (
      <AddCommentBox
        onCancel={this.props.onCancel}
        attachments={this.props.attachments}
        selected={this.props.selected}
        isCommentPosting={this.props.postingComment}
        completingIssue={this.props.completingIssue}
        usernameList={this.props.usernameList}
        user={this.props.user}
        onUploadAttachment={this.props.handleStartUploadAttachment}
        handleRemoveAttachment={this.props.handleRemoveAttachment}
        onCommentTextChange={this.handleCommentTextChange}
        handleAddComment={this.handleAddComment}
        startAddComment={this.props.startAddComment}
        updateTaggingList={this.props.updateTaggingList}
        disabled={isDisabled}
        value={this.state.value}
      />
    );
  }
}

export default AddComment;
